import { useNavigate, Link, useLocation} from 'react-router-dom';
import {useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { useEffect, useState,useRef } from 'react';
import UserMenu from './userMenu';
import CustomModal from './modals';
import queryString from 'query-string';
import AppContext from '../../AppContext';
import UserContext from '../../UserContext';

function HeaderMenu({reloadusercontext}) {
    const auth = useAuth();
    let navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userinitials, setUserInitials] = useState(false);
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [openMenuMobile, setOpenMenuMobile] = useState(false);
    const menuRef = useRef(null);
    const appcontext = useContext(AppContext);
    const usercontext = useContext(UserContext);
    const hasbundles2026=(appcontext && appcontext.features && (appcontext.features.bundle2026));


    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [modalType1, setModalType1] = useState('userLogout');
    const [modalType2, setModalType2] = useState('activateProduct');
    const [enableAttivaProdotto, setEnableAttivaProdotto] = useState(false);
    const effectRan = useRef(false);// use to avoid in dev mode double rendering after redirect, causing NS_BINDING_ERR: 

    const handleCloseModal1 = () => setShowModal1(false);
    const handleShowModal1 = (type) => {
        setModalType1(type);
        setShowModal1(true);
    };

    const handleCloseModal2 = () => setShowModal2(false);
    const handleShowModal2 = (type) => {
        setModalType2(type);
        setShowModal2(true);
    };
    const closeMenu = function () {
        setOpen(false);
    };

	useEffect(()=>{
		if((!enableAttivaProdotto) && auth && auth.isAuthenticated && usercontext && usercontext.user && usercontext.user.professione)setEnableAttivaProdotto(true);
		else if(enableAttivaProdotto) setEnableAttivaProdotto(false);
	},[auth,usercontext]);

	useEffect(()=>{
		if(!effectRan.current){
		//if(location.pathname==='/dashboard/'){
			const {show}=queryString.parse(location.search);
			if(show && show==='activateProduct'){
				closeMenu();handleShowModal2('activateProduct');
			}
		//}
	  		return () => effectRan.current = true;
		}
	},[closeMenu,location.pathname,location.search]);

    const handleSubmitModal1 = () => {
        doLogout();
        handleCloseModal1();
    };

    const handleSubmitModal2 = () => {
        // TODO logica di attivazione prodotto
        handleCloseModal2();
    };

    const modalContent1 = {
        userLogout: {
            title: 'Disconnessione utente',
            bodyContent: 'Per procedere con il logout, cliccare sul pulsante "Conferma". In caso contrario, cliccare su "Annulla" per rimanere connesso al tuo account Giappichelli',
            bodySubtitle: 'Stai per effettuare il logout dal tuo account. Questa operazione comporterà la chiusura di tutte le sessioni aperte',
        },
    };

    const modalContent2 = (hasbundles2026?{
        activateProduct: {
            icon: `${location.pathname === '/dashboard/' ? `${process.env.PUBLIC_URL}/activate-w.svg` : `${process.env.PUBLIC_URL}/activate.svg`}`,
            title: 'ESPANDI IL LIBRO',
            bodyContent: '',
            bodySubtitle: 'Dopo aver inserito il codice di sblocco potrai accedere al tuo prodotto digitale e scoprire tutte le funzionalità.',
            bodyContent1: 'Se stai attivando un libro con in copertina il tag "+eBook + Giappichelli edu" il tuo accesso gratuito alla versione eBook ed a Giappichelli edu sarà valido per ',
            bodyContentGreen: '6 mesi',
            bodyContent2: ' dal momento dell\'inserimento del codice.',
        },
    }:{
        activateProduct: {
            icon: `${location.pathname === '/dashboard/' ? `${process.env.PUBLIC_URL}/activate-w.svg` : `${process.env.PUBLIC_URL}/activate.svg`}`,
            title: 'ESPANDI IL LIBRO',
            bodyContent: '',
            bodySubtitle: 'Dopo aver inserito il codice di attivazione potrai accedere al tuo prodotto digitale e scoprire tutte le funzionalità.',
            bodyContent1: 'Se stai attivando un libro con in copertina il tag "Espandi questo libro su Giappichelli.it" il tuo accesso gratuito sarà valido per ',
            bodyContentGreen: '6 mesi',
            bodyContent2: ' dal momento dell\'inserimento del codice.',
        },
    });


    const handleCloseButtonClick1 = () => {
        handleCloseModal1();
    };

    const handleCloseButtonClick2 = () => {
        handleCloseModal2();
    };



    useEffect(() => {
        if (auth && auth.isAuthenticated && (!auth.isLoading) && (!auth.error)) {
            setIsAuthenticated(true);
        }
        if (auth && auth.user) {
            setUserInitials((auth.user?.profile.given_name?auth.user?.profile.given_name.substr(0, 1):'N') + (auth.user?.profile.family_name?auth.user?.profile.family_name.substr(0, 1):'A'));
        }
    }, [auth, userinitials]);

    const doLogout = async function () {
	//await fetch(process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account/logout',{credentials:'include'});
	//window.open(process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account/logout','_blank');
	auth.removeUser();
        auth.signoutRedirect();
	localStorage.clear();
	navigate('/api/session/logout/?redirect_uri='+encodeURIComponent(process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account/logout'));
        //navigate('/login/?redirect=' + encodeURIComponent(document.location.href));
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                closeMenu();
            }
        };

        if (open) {
            const timeoutId = setTimeout(() => {
                closeMenu();
            }, 3000); // esempio di 5 secondi

            document.addEventListener('mousedown', handleClickOutside);

            return () => {
                clearTimeout(timeoutId);
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [open, closeMenu]);
    


    return (
        <>
		{isAuthenticated && (location.pathname==='/' || location.pathname==='/dashboard/')?(
            <div className='header-wrapper'>
				<div className="row g-0 align-items-center header-dash-row">
					<div className='col-auto'>
                        <a alt="Logo Giappichelli" target='_blank' href='https://www.giappichelli.it/' rel="noopener noreferrer">
                            <picture>
                                <source media="(max-width: 980px)" srcSet={`${process.env.PUBLIC_URL}/logo-mobile-w.png`} alt="Logo Giappichelli" />
                                <img src={`${process.env.PUBLIC_URL}/giappichelli-logo-w.png`} alt="Logo Giappichelli" />
						    </picture>
                        </a>
					</div>
					<div className='col search'>
						<form action={`${process.env.REACT_APP_PREFIX_MAGENTO}/catalogsearch/result/`} method='get'>
							<input type='text' name='q' placeholder='Cerca Titolo, Autore o ISBN' required />
							<input type='submit' style={{ display: 'none' }} />
						</form>
					</div>
                    {/* <div 
                            className='col-auto open-menu-mobile open-menu-dash'
                            onClick={() => setOpenMenuMobile(!openMenuMobile)}
                            aria-controls="collapse-menu-mobile"
                            aria-expanded={openMenuMobile}
                        >
                    </div> */}
                    <div ref={menuRef} className={`menu-mobile menu-mobile-dash ${openMenuMobile ? 'show' : ''}`} id="collapse-menu-mobile">
                        <nav>
                            <div className='row align-items-center g-0 p-0'>
                                <div className='col'>
                                    <h4>Menu</h4>
                                </div>
                                <div className='col-auto'>
                                    <img
                                        onClick={() => setOpenMenuMobile(!openMenuMobile)} 
                                        src={`${process.env.PUBLIC_URL}/close-menu.svg`} alt="Chiudi menu" 
                                    />
                                </div>
                            </div>

                            <ul>
                                <li>
                                    <a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/studenti-home`}>Università</a>
                                    <ul>
                                        <li><a>Studenti</a></li>
                                        <li><a>Docenti</a></li>
                                    </ul>
                                </li>
                                <li><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/professionisti-home`}>Professionale</a></li>
                                <li><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/biblioteche-home`}>Enti e Biblioteche</a></li>
                                <li className='menu-activate'><a href='?show=activateProduct'>Attiva prodotto</a></li>
                                <li><a>FAQ</a></li>
                            </ul>
                        </nav>
                    </div>
                    <div className='col search-mobile'>
                        <form
                            className={`search-mobile-form ${openSearch ? 'show' : ''}`}
                            id="collapse-search"
                            action={`${process.env.REACT_APP_PREFIX_MAGENTO}/catalogsearch/result/`} method='get'
                        >
                            <input type='text' name='q' placeholder='Cerca Titolo, Autore o ISBN' required />
                            <input type='submit' style={{ display: 'none' }} />
                        </form>
                        <img
                            onClick={() => setOpenSearch(!openSearch)}
                            aria-controls="collapse-search"
                            aria-expanded={openSearch}
                            src={`${process.env.PUBLIC_URL}/search-mobile-w.svg`} alt="Cerca su Giappichelli"
                        />
                    </div>
					<div className='col-auto expandbook'>
                            			{enableAttivaProdotto ? (<>
							<button onClick={()=>{handleShowModal2('activateProduct');}}><span className='mobilebtn' title='Inserisci codice'>+</span><span className='desktopbtn' title='Inserisci codice'>Inserisci codice</span></button>
                        			    </>) : (
                       				         <button><Link to="/attivaprodotto/"><span className='mobilebtn' title='Inserisci codice'>+</span><span className='desktopbtn' title='Inserisci codice'>Inserisci codice</span></Link></button>
                       				     )}
					</div>
					<div className='col-auto faq'>
						<Link to="/help-center/">
						<img src={`${process.env.PUBLIC_URL}/icon-question-w.svg`} alt="FAQ" />
						</Link>
					</div>
					<div className='col-auto open-menu'>
						<button
							onClick={() => setOpen(!open)}
							aria-controls="collapse-menu"
							aria-expanded={open}>{userinitials ? userinitials : 'U'}
						</button>
						<UserMenu open={open} doLogout={doLogout} closeMenu={()=>{closeMenu();}} reloadusercontext={reloadusercontext} handleShowModal1={handleShowModal1} handleShowModal2={handleShowModal2} />
					</div>
				</div>
			</div>
        ):(
            <>
                {(!['/register/','/register','/forgot-password','/forgot-password/','/profilo/primoaccesso','/profilo/primoaccesso/','/'].includes(location.pathname)) && <div className='header-wrapper header-row-top'>
                    <div className="row g-0 align-items-center header-row-top">
			{!['/attivaprodotto','/attivaprodotto/','/attivaomaggio','/attivaomaggio/','/attivaebook','/attivaebook/','/attivaebookedu','/attivaebookedu/','/attivadaecomm','/attivadaecomm/'].includes(location.pathname)?(<>
                        <div className='col-auto'><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/studenti-home`}>università</a></div>
                        <div className='col-auto'><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/professionisti-home`}>professionale</a></div>
                        <div className='col-auto'><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/biblioteche-home`}>enti e biblioteche</a></div>
                        <div className='col d-flex justify-content-end'>
                            <a href="?show=activateProduct"><button><span>Attiva Prodotto</span></button></a>
                        </div>
			</>):(<></>)}
                    </div>
                </div>}
                <div className='header-wrapper header-row-bottom'>
                    <div className="row h-100 g-0 align-items-center">
                        <div className='col-auto'>
                            <a alt="Logo Giappichelli" href='https://www.giappichelli.it/' target='_blank' rel="noopener noreferrer">
                                <picture>
                                    <source media="(max-width: 980px)" srcSet={`${process.env.PUBLIC_URL}/logo-mobile.png`} alt="Logo Giappichelli" />
                                    <img src={`${process.env.PUBLIC_URL}/giappichelli-logo.png`} alt="Logo Giappichelli" />
                                </picture>
                            </a>
                        </div>
                        <div className='col search'>
                            <form action={`${process.env.REACT_APP_PREFIX_MAGENTO}/catalogsearch/result/`} method='get'>
                                <input type='text' name='q' placeholder='Cerca Titolo, Autore o ISBN' required />
                                <input type='submit' style={{ display: 'none' }} />
                            </form>
                        </div>
                        {/* <div 
                            className='col-auto open-menu-mobile'
                            onClick={() => setOpenMenuMobile(!openMenuMobile)}
                            aria-controls="collapse-menu-mobile"
                            aria-expanded={openMenuMobile}
                        >
                        </div> */}
                        <div ref={menuRef} className={`menu-mobile menu-mobile ${openMenuMobile ? 'show' : ''}`} id="collapse-menu-mobile">
                        <nav>
                            <div className='row align-items-center g-0 p-0'>
                                <div className='col'>
                                    <h4>Menu</h4>
                                </div>
                                <div className='col-auto'>
                                    <img
                                        onClick={() => setOpenMenuMobile(!openMenuMobile)} 
                                        src={`${process.env.PUBLIC_URL}/close-menu.svg`} alt="Chiudi menu" 
                                    />
                                </div>
                            </div>

                            <ul>
                                <li>
                                    <a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/studenti-home`}>Università</a>
                                    <ul>
                                        <li><a>Studenti</a></li>
                                        <li><a>Docenti</a></li>
                                    </ul>
                                </li>
                                <li><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/professionisti-home`}>Professionale</a></li>
                                <li><a href={`${process.env.REACT_APP_PREFIX_MAGENTO}/biblioteche-home`}>Enti e Biblioteche</a></li>
                                <li className='menu-activate'><a href='?show=activateProduct'>Attiva prodotto</a></li>
                                <li><a>FAQ</a></li>
                            </ul>
                        </nav>
                    </div>
                        <div className='col search-mobile'>
                            <form
                                className={`search-mobile-form ${openSearch ? 'show' : ''}`}
                                id="collapse-search"
                                action={`${process.env.REACT_APP_PREFIX_MAGENTO}/catalogsearch/result/`} method='get'
                            >
                                <input type='text' name='q' placeholder='Cerca Titolo, Autore o ISBN' required />
                                <input type='submit' style={{ display: 'none' }} />
                            </form>
                            <img
                                onClick={() => setOpenSearch(!openSearch)}
                                aria-controls="collapse-search"
                                aria-expanded={openSearch}
                                src={`${process.env.PUBLIC_URL}/search-mobile.svg`} alt="Cerca su Giappichelli"
                            />
                        </div>
			<div className='col-auto expandbook'>
                            {enableAttivaProdotto ? (<>
				<button onClick={()=>{handleShowModal2('activateProduct');}}><span className='mobilebtn' title='Inserisci codice'>+</span><span className='desktopbtn' title='Inserisci codice'>Inserisci codice</span></button>
                            </>) : (
                                <button><Link to="/attivaprodotto/"><span className='mobilebtn' title='Inserisci codice'>+</span><span className='desktopbtn' title='Inserisci codice'>Inserisci codice</span></Link></button>
                            )}
			</div>
                        <div className='col-auto faq'>
                            <Link to="/help-center/">
                            <img src={`${process.env.PUBLIC_URL}/icon-question.svg`} alt="FAQ" />
                            </Link>
                        </div>
                        <div className='col-auto open-menu'>
                            {auth.isAuthenticated ? (<>
                                <button
                                    className='active-user'
                                    onClick={() => setOpen(!open)}
                                    aria-controls="collapse-menu"
                                    aria-expanded={open}>{userinitials ? userinitials : 'U'}
                                </button>
                                <UserMenu open={open} doLogout={doLogout} closeMenu={() => { closeMenu(); }} reloadusercontext={reloadusercontext} handleShowModal1={handleShowModal1} handleShowModal2={handleShowModal2} />
                            </>) : (
                                <button><Link to="/login/">Accedi</Link></button>
                            )}
                        </div>
                    </div>
                </div>
		    </>)}
            {/* Modali */}
            <CustomModal
                modalType={modalType1}
                showModal={showModal1}
                handleClose={handleCloseModal1}
                handleSubmit={handleSubmitModal1}
                title={modalContent1[modalType1].title}
                bodyContent={modalContent1[modalType1].bodyContent}
                bodySubtitle={modalContent1[modalType1].bodySubtitle}
                closeButtonAction={handleCloseButtonClick1}
                closeButtonText="Chiudi"
                confirmButtonText="Conferma"
            />

            <CustomModal
                modalType={modalType2}
                showModal={showModal2}
                handleClose={handleCloseModal2}
                handleSubmit={handleSubmitModal2}
                icon={modalContent2[modalType2].icon}
                title={modalContent2[modalType2].title}
                bodyContent={modalContent2[modalType2].bodyContent}
                bodySubtitle={modalContent2[modalType2].bodySubtitle}
                bodyContent1={modalContent2[modalType2].bodyContent1}
                bodyContentGreen={modalContent2[modalType2].bodyContentGreen}
                bodyContent2={modalContent2[modalType2].bodyContent2}
                closeButtonAction={handleCloseButtonClick2}
                closeButtonText="Chiudi"
                confirmButtonText="Conferma"
		reloadusercontext={reloadusercontext}
            />

        </>
    )
}

export default HeaderMenu;
